// Google Tag Manager utilities

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

/**
 * Push event to GTM dataLayer
 */
export const gtmEvent = (event: string, category: string, action: string, label: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    category,
    action,
    label
  });
};

/**
 * Send login success event
 */
export const gtmLoginSuccess = () => {
  gtmEvent('login_success', 'User', 'Login', 'Personal_Cabinet');
};

/**
 * Send signup success event
 */
export const gtmSignupSuccess = () => {
  gtmEvent('signup_success', 'User', 'SignUp', 'Personal_Cabinet');
};

/**
 * Send create game account event
 */
export const gtmCreateAccount = () => {
  gtmEvent('create_account', 'User', 'CreateAccount', 'Personal_Cabinet');
};

/**
 * Send email confirmation event
 */
export const gtmConfirmEmail = () => {
  gtmEvent('confirm_email', 'User', 'ConfirmEmail', 'Personal_Cabinet');
};

/**
 * Update Google consent via GTM dataLayer (called from CookieBanner)
 */
export const gtmUpdateConsent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_update',
    consent: {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted'
    }
  });
};
